import { Box, Grid } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./trainingListingFilter.scss";
import Stack from "@mui/material/Stack";
import Dropdown from "../../components/common/Dropdown";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import ToggleButton from "../ToggleButton";
import DateRangePicker from "../DateRangePicker/index";
import { API, ROLE, STATUS, APP_ROUTES } from "../../globals/constants/index";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { useDispatch, useSelector } from "react-redux";
import { TrainingListingPageFilter } from "../../redux/filter/FilterRedux";
import Button from "../common/Button";

const TrainingListingFilter = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    instructorList,
    studioList,
    getTrainingList,
    state,
    showTrainingListingDetails,
  } = props;
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [searchBytrainingName, setSearchBytrainingName] = useState();
  const [instructor, setInstructor] = useState();
  const [studio, setStudio] = useState();

  useEffect(() => {
    // getTrainingList({searchBytrainingName,instructor,studio})
    let body = { searchBytrainingName, instructor, studio };
    dispatch(TrainingListingPageFilter(body));
  }, [searchBytrainingName, instructor, studio]);

  // Extra feature: Reset instructor when studio is selected
  // useEffect(() => {
  //   setInstructor("");
  //   dispatch(TrainingListingPageFilter({ instructor: "" }));
  // }, [studio]);

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 50,
    height: 25,
    padding: 0,
    borderRadius: 30,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 20,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(15px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(25px)",
        color: "#0C0D16",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 20,
      height: 20,
      borderRadius: 30,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark" ? "rgba(0,0,0,.25)" : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
  }));

  const closeFilter = () => {
    setSearchBytrainingName("");
    setInstructor("");
    setStudio("");
    setShowDateFilter(false);
    // getTrainingList();
  };

  const createSession = () => {
    navigate(APP_ROUTES.ROUTE_CREATESESSION, { state: {} });
  };

  return (
    <>
      <Stack className='filterContainer'>
        <Grid container>
          <Grid item xs={12} sm={4} md={4} lg={6}>
            <Stack direction='row'>
              <Stack className='larger_f_bold' sx={{ mr: 4 }}>
                Training
              </Stack>

              {showTrainingListingDetails
                ? ""
                : props?.showToggle && (
                    <Stack>
                      <ToggleButton
                        value={props?.gridview}
                        onClick={props?.setGridViewfun}
                      />
                    </Stack>
                  )}
            </Stack>
          </Grid>
          <Grid item xs={12} sm={8} md={8} lg={6}>
            <Grid container justifyContent='space-evenly'>
              <Box class=''>
                <input
                  type='text'
                  class='FilterSearch'
                  placeholder='Search'
                  aria-label="Recipient's username with two button addons"
                  onChange={(e) => setSearchBytrainingName(e.target.value)}
                />
              </Box>

              <Box>
                {/* <input
									type="button"
									value="Filter"
									// className="FilterButton"
									onClick={() => setShowDateFilter(true)}
								/> */}
                <Button
                  value='Filter'
                  role='filter'
                  onClick={() => {
                    setShowDateFilter(true);
                  }}
                />
              </Box>
              <Box>
                <input
                  type='button'
                  value='Create Session'
                  className='createSessionButton filter_bolderFont'
                  onClick={createSession}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Stack>
      {showDateFilter && (
        <Stack className='lowerFilterContainer'>
          <Grid container direction='row' alignItems='center'>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <DateRangePicker getTrainingList={getTrainingList} />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={2}>
              {/* <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="center"
              >
                <span className="small_f">Private</span>
                <AntSwitch
                  defaultChecked
                  inputProps={{ "aria-label": "ant design" }}
                />
                <span className="small_f">Public</span>
              </Stack> */}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Grid container rowSpacing={2} columnSpacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {props.roleCode === "STUDIO_ADMIN" ||
                  props.roleCode === "INSTRUCTOR" ? (
                    ""
                  ) : (
                    <Dropdown
                      clearable
                      value={
                        state?.tcAdmin_id
                          ? state?.tcAdmin_id &&
                            studioList?.filter(
                              (stud) => stud?.value === state?.tcAdmin_id
                            )
                          : state?.studio_id &&
                            state?.studio_id &&
                            studioList?.filter(
                              (stud) => stud?.value === state?.studio_id
                            )
                      }
                      options={studioList}
                      selection
                      placeholder='Training Center Name'
                      onChange={(e) => setStudio(e.value)}
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {props.roleCode === "INSTRUCTOR" ? (
                    ""
                  ) : (
                    <Dropdown
                      clearable
                      value={
                        state?.instructor_id &&
                        instructorList?.filter(
                          (inst) => inst?.value === state?.instructor_id
                        )
                      }
                      options={instructorList}
                      selection
                      placeholder='select instructor'
                      onChange={(e) => setInstructor(e.value)}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={2}>
              <button className='clearButton' onClick={() => closeFilter()}>
                Clear Filter
              </button>
            </Grid>
          </Grid>
        </Stack>
      )}
    </>
  );
};

export default TrainingListingFilter;
